/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosInstance } from 'axios';

const baseUrl = `/api/internal/tasks`;

export const tasksClient = (request: AxiosInstance) => ({
  async getCurrentTask() {
    return (await request.get(`${baseUrl}/current`)).data;
  },

  async submitTask(taskId: string, inputValues: {}) {
    return (await request.post(`${baseUrl}/${taskId}/submit`, { inputValues })).data;
  },

  async backToUserSelect() {
    return (await request.post(`${baseUrl}/back-to-user-select`)).data;
  },
});
